module.exports = __webpack_public_path__ + "img/imagen2.1859818a.png";